(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

// Likes
var negativeButton = document.querySelector('.prev');
var positive = document.querySelector('.next');

var Likes = /*#__PURE__*/function () {
  function Likes(selector) {
    _classCallCheck(this, Likes);

    this.cookieObj = {
      type: "",
      uuid: "",
      toString: function toString() {
        return '{"type": "' + this.type + '", "uuid": "' + this.uuid + '"}';
      },
      toUrl: function toUrl() {
        return 'type=' + this.type + '&uuid=' + this.uuid;
      }
    };
    this.baseClass = selector.split('.')[1];
    this.selector = selector;
    this.buttonPositive = document.querySelector(selector + '__itm__positive');
    this.buttonNegative = document.querySelector(selector + '__itm__negative');
    this.setPositiveValue = this.setPositiveValue.bind(this);
    this.buttonPositive.addEventListener('click', this.setPositiveValue);
    this.setNegativeValue = this.setNegativeValue.bind(this);
    this.buttonNegative.addEventListener('click', this.setNegativeValue);
    this.send = this.send.bind(this);
    this.getCookieObj = this.getCookieObj.bind(this);

    if (document.cookie.split(';').filter(function (item) {
      return item.trim().startsWith('likes=');
    }).length) {
      this.getCookieObj();

      if (this.cookieObj.type == "like") {
        this.buttonPositive.classList.add(this.baseClass + '__itm' + "--active");
      }

      if (this.cookieObj.type == "dislike") {
        this.buttonNegative.classList.add(this.baseClass + '__itm' + "--active");
      }
    } else {
      this.cookieObj.uuid = this.uuidv4();
    }
  }

  _createClass(Likes, [{
    key: "setPositiveValue",
    value: function setPositiveValue() {
      var elements = document.querySelectorAll(this.selector + '__itm');

      var _iterator = _createForOfIteratorHelper(elements),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var elem = _step.value;
          elem.classList.remove(this.baseClass + '__itm' + "--active");
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      this.buttonPositive.classList.add(this.baseClass + '__itm' + "--active");
      this.cookieObj.type = "like";
      document.cookie = "likes=" + this.cookieObj;
      this.send();
    }
  }, {
    key: "setNegativeValue",
    value: function setNegativeValue() {
      var elements = document.querySelectorAll(this.selector + '__itm');

      var _iterator2 = _createForOfIteratorHelper(elements),
          _step2;

      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var elem = _step2.value;
          elem.classList.remove(this.baseClass + '__itm' + "--active");
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }

      this.buttonNegative.classList.add(this.baseClass + '__itm' + "--active");
      this.cookieObj.type = "like";
      this.cookieObj.type = "dislike";
      document.cookie = "likes=" + this.cookieObj;
      this.send();
    }
  }, {
    key: "getCookieObj",
    value: function getCookieObj() {
      try {
        var obj = JSON.parse(document.cookie.replace(/(?:(?:^|.*;\s*)likes\s*\=\s*([^;]*).*$)|^.*$/, "$1"));
        this.cookieObj.uuid = obj.uuid;
        this.cookieObj.type = obj.type;
      } catch (e) {
        this.cookieObj.uuidv4 = this.uuidv4();
        console.log(e);
      }
    }
  }, {
    key: "send",
    value: function send() {
      var uri = this.cookieObj.toUrl();
      var request = new XMLHttpRequest();

      request.onload = function () {
        var data = JSON.parse(this.responseText);
      };

      request.onerror = function (e) {
        console.log('Ошибка отправки данных о лайке на сервер', e);
      };

      request.open('get', 'https://fmdev.ru/likes_api/?' + uri, true);
      request.send();
    }
  }, {
    key: "uuidv4",
    value: function uuidv4() {
      return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        var r = Math.random() * 16 | 0,
            v = c == 'x' ? r : r & 0x3 | 0x8;
        return v.toString(16);
      });
    }
  }]);

  return Likes;
}();

var _default = Likes;
exports["default"] = _default;

},{}],2:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var Siema = /*#__PURE__*/function () {
  /**
   * Create a Siema.
   * @param {Object} options - Optional settings object.
   */
  function Siema(options) {
    var _this = this;

    _classCallCheck(this, Siema);

    // Merge defaults with user's settings
    this.config = Siema.mergeSettings(options); // Resolve selector's type

    this.selector = typeof this.config.selector === 'string' ? document.querySelector(this.config.selector) : this.config.selector; // Early throw if selector doesn't exists

    if (this.selector === null) {
      throw new Error('Something wrong with your selector 😭');
    } // update perPage number dependable of user value


    this.resolveSlidesNumber(); // Create global references

    this.selectorWidth = this.selector.offsetWidth;
    this.innerElements = [].slice.call(this.selector.children);
    this.currentSlide = this.config.loop ? this.config.startIndex % this.innerElements.length : Math.max(0, Math.min(this.config.startIndex, this.innerElements.length - this.perPage));
    this.transformProperty = Siema.webkitOrNot(); // Bind all event handlers for referencability

    ['resizeHandler', 'touchstartHandler', 'touchendHandler', 'touchmoveHandler', 'mousedownHandler', 'mouseupHandler', 'mouseleaveHandler', 'mousemoveHandler', 'clickHandler'].forEach(function (method) {
      _this[method] = _this[method].bind(_this);
    }); // Build markup and apply required styling to elements

    this.init();
  }
  /**
   * Overrides default settings with custom ones.
   * @param {Object} options - Optional settings object.
   * @returns {Object} - Custom Siema settings.
   */


  _createClass(Siema, [{
    key: "attachEvents",

    /**
     * Attaches listeners to required events.
     */
    value: function attachEvents() {
      // Resize element on window resize
      window.addEventListener('resize', this.resizeHandler); // If element is draggable / swipable, add event handlers

      if (this.config.draggable) {
        // Keep track pointer hold and dragging distance
        this.pointerDown = false;
        this.drag = {
          startX: 0,
          endX: 0,
          startY: 0,
          letItGo: null,
          preventClick: false
        }; // Touch events

        this.selector.addEventListener('touchstart', this.touchstartHandler);
        this.selector.addEventListener('touchend', this.touchendHandler);
        this.selector.addEventListener('touchmove', this.touchmoveHandler); // Mouse events

        this.selector.addEventListener('mousedown', this.mousedownHandler);
        this.selector.addEventListener('mouseup', this.mouseupHandler);
        this.selector.addEventListener('mouseleave', this.mouseleaveHandler);
        this.selector.addEventListener('mousemove', this.mousemoveHandler); // Click

        this.selector.addEventListener('click', this.clickHandler);
      }
    }
    /**
     * Detaches listeners from required events.
     */

  }, {
    key: "detachEvents",
    value: function detachEvents() {
      window.removeEventListener('resize', this.resizeHandler);
      this.selector.removeEventListener('touchstart', this.touchstartHandler);
      this.selector.removeEventListener('touchend', this.touchendHandler);
      this.selector.removeEventListener('touchmove', this.touchmoveHandler);
      this.selector.removeEventListener('mousedown', this.mousedownHandler);
      this.selector.removeEventListener('mouseup', this.mouseupHandler);
      this.selector.removeEventListener('mouseleave', this.mouseleaveHandler);
      this.selector.removeEventListener('mousemove', this.mousemoveHandler);
      this.selector.removeEventListener('click', this.clickHandler);
    }
    /**
     * Builds the markup and attaches listeners to required events.
     */

  }, {
    key: "init",
    value: function init() {
      this.attachEvents(); // hide everything out of selector's boundaries

      this.selector.style.overflow = 'hidden'; // rtl or ltr

      this.selector.style.direction = this.config.rtl ? 'rtl' : 'ltr'; // build a frame and slide to a currentSlide

      this.buildSliderFrame();
      this.config.onInit.call(this);
    }
    /**
     * Build a sliderFrame and slide to a current item.
     */

  }, {
    key: "buildSliderFrame",
    value: function buildSliderFrame() {
      var widthItem = this.selectorWidth / this.perPage;
      var itemsToBuild = this.config.loop ? this.innerElements.length + 2 * this.perPage : this.innerElements.length; // Create frame and apply styling

      this.sliderFrame = document.createElement('div');
      this.sliderFrame.style.width = "".concat(widthItem * itemsToBuild, "px");
      this.enableTransition();

      if (this.config.draggable) {
        this.selector.style.cursor = '-webkit-grab';
      } // Create a document fragment to put slides into it


      var docFragment = document.createDocumentFragment(); // Loop through the slides, add styling and add them to document fragment

      if (this.config.loop) {
        for (var i = this.innerElements.length - this.perPage; i < this.innerElements.length; i++) {
          var element = this.buildSliderFrameItem(this.innerElements[i].cloneNode(true));
          docFragment.appendChild(element);
        }
      }

      for (var _i = 0; _i < this.innerElements.length; _i++) {
        var _element = this.buildSliderFrameItem(this.innerElements[_i]);

        docFragment.appendChild(_element);
      }

      if (this.config.loop) {
        for (var _i2 = 0; _i2 < this.perPage; _i2++) {
          var _element2 = this.buildSliderFrameItem(this.innerElements[_i2].cloneNode(true));

          docFragment.appendChild(_element2);
        }
      } // Add fragment to the frame


      this.sliderFrame.appendChild(docFragment); // Clear selector (just in case something is there) and insert a frame

      this.selector.innerHTML = '';
      this.selector.appendChild(this.sliderFrame); // Go to currently active slide after initial build

      this.slideToCurrent();
    }
  }, {
    key: "buildSliderFrameItem",
    value: function buildSliderFrameItem(elm) {
      var elementContainer = document.createElement('div');
      elementContainer.style.cssFloat = this.config.rtl ? 'right' : 'left';
      elementContainer.style["float"] = this.config.rtl ? 'right' : 'left';
      elementContainer.style.width = "".concat(this.config.loop ? 100 / (this.innerElements.length + this.perPage * 2) : 100 / this.innerElements.length, "%");
      elementContainer.appendChild(elm);
      return elementContainer;
    }
    /**
     * Determinates slides number accordingly to clients viewport.
     */

  }, {
    key: "resolveSlidesNumber",
    value: function resolveSlidesNumber() {
      if (typeof this.config.perPage === 'number') {
        this.perPage = this.config.perPage;
      } else if (_typeof(this.config.perPage) === 'object') {
        this.perPage = 1;

        for (var viewport in this.config.perPage) {
          if (window.innerWidth >= viewport) {
            this.perPage = this.config.perPage[viewport];
          }
        }
      }
    }
    /**
     * Go to previous slide.
     * @param {number} [howManySlides=1] - How many items to slide backward.
     * @param {function} callback - Optional callback function.
     */

  }, {
    key: "prev",
    value: function prev() {
      var howManySlides = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
      var callback = arguments.length > 1 ? arguments[1] : undefined;

      // early return when there is nothing to slide
      if (this.innerElements.length <= this.perPage) {
        return;
      }

      var beforeChange = this.currentSlide;

      if (this.config.loop) {
        var isNewIndexClone = this.currentSlide - howManySlides < 0;

        if (isNewIndexClone) {
          this.disableTransition();
          var mirrorSlideIndex = this.currentSlide + this.innerElements.length;
          var mirrorSlideIndexOffset = this.perPage;
          var moveTo = mirrorSlideIndex + mirrorSlideIndexOffset;
          var offset = (this.config.rtl ? 1 : -1) * moveTo * (this.selectorWidth / this.perPage);
          var dragDistance = this.config.draggable ? this.drag.endX - this.drag.startX : 0;
          this.sliderFrame.style[this.transformProperty] = "translate3d(".concat(offset + dragDistance, "px, 0, 0)");
          this.currentSlide = mirrorSlideIndex - howManySlides;
        } else {
          this.currentSlide = this.currentSlide - howManySlides;
        }
      } else {
        this.currentSlide = Math.max(this.currentSlide - howManySlides, 0);
      }

      if (beforeChange !== this.currentSlide) {
        this.slideToCurrent(this.config.loop);
        this.config.onChange.call(this);

        if (callback) {
          callback.call(this);
        }
      }
    }
    /**
     * Go to next slide.
     * @param {number} [howManySlides=1] - How many items to slide forward.
     * @param {function} callback - Optional callback function.
     */

  }, {
    key: "next",
    value: function next() {
      var howManySlides = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
      var callback = arguments.length > 1 ? arguments[1] : undefined;

      // early return when there is nothing to slide
      if (this.innerElements.length <= this.perPage) {
        return;
      }

      var beforeChange = this.currentSlide;

      if (this.config.loop) {
        var isNewIndexClone = this.currentSlide + howManySlides > this.innerElements.length - this.perPage;

        if (isNewIndexClone) {
          this.disableTransition();
          var mirrorSlideIndex = this.currentSlide - this.innerElements.length;
          var mirrorSlideIndexOffset = this.perPage;
          var moveTo = mirrorSlideIndex + mirrorSlideIndexOffset;
          var offset = (this.config.rtl ? 1 : -1) * moveTo * (this.selectorWidth / this.perPage);
          var dragDistance = this.config.draggable ? this.drag.endX - this.drag.startX : 0;
          this.sliderFrame.style[this.transformProperty] = "translate3d(".concat(offset + dragDistance, "px, 0, 0)");
          this.currentSlide = mirrorSlideIndex + howManySlides;
        } else {
          this.currentSlide = this.currentSlide + howManySlides;
        }
      } else {
        this.currentSlide = Math.min(this.currentSlide + howManySlides, this.innerElements.length - this.perPage);
      }

      if (beforeChange !== this.currentSlide) {
        this.slideToCurrent(this.config.loop);
        this.config.onChange.call(this);

        if (callback) {
          callback.call(this);
        }
      }
    }
    /**
     * Disable transition on sliderFrame.
     */

  }, {
    key: "disableTransition",
    value: function disableTransition() {
      this.sliderFrame.style.webkitTransition = "all 0ms ".concat(this.config.easing);
      this.sliderFrame.style.transition = "all 0ms ".concat(this.config.easing);
    }
    /**
     * Enable transition on sliderFrame.
     */

  }, {
    key: "enableTransition",
    value: function enableTransition() {
      this.sliderFrame.style.webkitTransition = "all ".concat(this.config.duration, "ms ").concat(this.config.easing);
      this.sliderFrame.style.transition = "all ".concat(this.config.duration, "ms ").concat(this.config.easing);
    }
    /**
     * Go to slide with particular index
     * @param {number} index - Item index to slide to.
     * @param {function} callback - Optional callback function.
     */

  }, {
    key: "goTo",
    value: function goTo(index, callback) {
      if (this.innerElements.length <= this.perPage) {
        return;
      }

      var beforeChange = this.currentSlide;
      this.currentSlide = this.config.loop ? index % this.innerElements.length : Math.min(Math.max(index, 0), this.innerElements.length - this.perPage);

      if (beforeChange !== this.currentSlide) {
        this.slideToCurrent();
        this.config.onChange.call(this);

        if (callback) {
          callback.call(this);
        }
      }
    }
    /**
     * Moves sliders frame to position of currently active slide
     */

  }, {
    key: "slideToCurrent",
    value: function slideToCurrent(enableTransition) {
      var _this2 = this;

      var currentSlide = this.config.loop ? this.currentSlide + this.perPage : this.currentSlide;
      var offset = (this.config.rtl ? 1 : -1) * currentSlide * (this.selectorWidth / this.perPage);

      if (enableTransition) {
        // This one is tricky, I know but this is a perfect explanation:
        // https://youtu.be/cCOL7MC4Pl0
        requestAnimationFrame(function () {
          requestAnimationFrame(function () {
            _this2.enableTransition();

            _this2.sliderFrame.style[_this2.transformProperty] = "translate3d(".concat(offset, "px, 0, 0)");
          });
        });
      } else {
        this.sliderFrame.style[this.transformProperty] = "translate3d(".concat(offset, "px, 0, 0)");
      }
    }
    /**
     * Recalculate drag /swipe event and reposition the frame of a slider
     */

  }, {
    key: "updateAfterDrag",
    value: function updateAfterDrag() {
      var movement = (this.config.rtl ? -1 : 1) * (this.drag.endX - this.drag.startX);
      var movementDistance = Math.abs(movement);
      var howManySliderToSlide = this.config.multipleDrag ? Math.ceil(movementDistance / (this.selectorWidth / this.perPage)) : 1;
      var slideToNegativeClone = movement > 0 && this.currentSlide - howManySliderToSlide < 0;
      var slideToPositiveClone = movement < 0 && this.currentSlide + howManySliderToSlide > this.innerElements.length - this.perPage;

      if (movement > 0 && movementDistance > this.config.threshold && this.innerElements.length > this.perPage) {
        this.prev(howManySliderToSlide);
      } else if (movement < 0 && movementDistance > this.config.threshold && this.innerElements.length > this.perPage) {
        this.next(howManySliderToSlide);
      }

      this.slideToCurrent(slideToNegativeClone || slideToPositiveClone);
    }
    /**
     * When window resizes, resize slider components as well
     */

  }, {
    key: "resizeHandler",
    value: function resizeHandler() {
      // update perPage number dependable of user value
      this.resolveSlidesNumber(); // relcalculate currentSlide
      // prevent hiding items when browser width increases

      if (this.currentSlide + this.perPage > this.innerElements.length) {
        this.currentSlide = this.innerElements.length <= this.perPage ? 0 : this.innerElements.length - this.perPage;
      }

      this.selectorWidth = this.selector.offsetWidth;
      this.buildSliderFrame();
    }
    /**
     * Clear drag after touchend and mouseup event
     */

  }, {
    key: "clearDrag",
    value: function clearDrag() {
      this.drag = {
        startX: 0,
        endX: 0,
        startY: 0,
        letItGo: null,
        preventClick: this.drag.preventClick
      };
    }
    /**
     * touchstart event handler
     */

  }, {
    key: "touchstartHandler",
    value: function touchstartHandler(e) {
      // Prevent dragging / swiping on inputs, selects and textareas
      var ignoreSiema = ['TEXTAREA', 'OPTION', 'INPUT', 'SELECT'].indexOf(e.target.nodeName) !== -1;

      if (ignoreSiema) {
        return;
      }

      e.stopPropagation();
      this.pointerDown = true;
      this.drag.startX = e.touches[0].pageX;
      this.drag.startY = e.touches[0].pageY;
    }
    /**
     * touchend event handler
     */

  }, {
    key: "touchendHandler",
    value: function touchendHandler(e) {
      e.stopPropagation();
      this.pointerDown = false;
      this.enableTransition();

      if (this.drag.endX) {
        this.updateAfterDrag();
      }

      this.clearDrag();
    }
    /**
     * touchmove event handler
     */

  }, {
    key: "touchmoveHandler",
    value: function touchmoveHandler(e) {
      e.stopPropagation();

      if (this.drag.letItGo === null) {
        this.drag.letItGo = Math.abs(this.drag.startY - e.touches[0].pageY) < Math.abs(this.drag.startX - e.touches[0].pageX);
      }

      if (this.pointerDown && this.drag.letItGo) {
        e.preventDefault();
        this.drag.endX = e.touches[0].pageX;
        this.sliderFrame.style.webkitTransition = "all 0ms ".concat(this.config.easing);
        this.sliderFrame.style.transition = "all 0ms ".concat(this.config.easing);
        var currentSlide = this.config.loop ? this.currentSlide + this.perPage : this.currentSlide;
        var currentOffset = currentSlide * (this.selectorWidth / this.perPage);
        var dragOffset = this.drag.endX - this.drag.startX;
        var offset = this.config.rtl ? currentOffset + dragOffset : currentOffset - dragOffset;
        this.sliderFrame.style[this.transformProperty] = "translate3d(".concat((this.config.rtl ? 1 : -1) * offset, "px, 0, 0)");
      }
    }
    /**
     * mousedown event handler
     */

  }, {
    key: "mousedownHandler",
    value: function mousedownHandler(e) {
      // Prevent dragging / swiping on inputs, selects and textareas
      var ignoreSiema = ['TEXTAREA', 'OPTION', 'INPUT', 'SELECT'].indexOf(e.target.nodeName) !== -1;

      if (ignoreSiema) {
        return;
      }

      e.preventDefault();
      e.stopPropagation();
      this.pointerDown = true;
      this.drag.startX = e.pageX;
    }
    /**
     * mouseup event handler
     */

  }, {
    key: "mouseupHandler",
    value: function mouseupHandler(e) {
      e.stopPropagation();
      this.pointerDown = false;
      this.selector.style.cursor = '-webkit-grab';
      this.enableTransition();

      if (this.drag.endX) {
        this.updateAfterDrag();
      }

      this.clearDrag();
    }
    /**
     * mousemove event handler
     */

  }, {
    key: "mousemoveHandler",
    value: function mousemoveHandler(e) {
      e.preventDefault();

      if (this.pointerDown) {
        // if dragged element is a link
        // mark preventClick prop as a true
        // to detemine about browser redirection later on
        if (e.target.nodeName === 'A') {
          this.drag.preventClick = true;
        }

        this.drag.endX = e.pageX;
        this.selector.style.cursor = '-webkit-grabbing';
        this.sliderFrame.style.webkitTransition = "all 0ms ".concat(this.config.easing);
        this.sliderFrame.style.transition = "all 0ms ".concat(this.config.easing);
        var currentSlide = this.config.loop ? this.currentSlide + this.perPage : this.currentSlide;
        var currentOffset = currentSlide * (this.selectorWidth / this.perPage);
        var dragOffset = this.drag.endX - this.drag.startX;
        var offset = this.config.rtl ? currentOffset + dragOffset : currentOffset - dragOffset;
        this.sliderFrame.style[this.transformProperty] = "translate3d(".concat((this.config.rtl ? 1 : -1) * offset, "px, 0, 0)");
      }
    }
    /**
     * mouseleave event handler
     */

  }, {
    key: "mouseleaveHandler",
    value: function mouseleaveHandler(e) {
      if (this.pointerDown) {
        this.pointerDown = false;
        this.selector.style.cursor = '-webkit-grab';
        this.drag.endX = e.pageX;
        this.drag.preventClick = false;
        this.enableTransition();
        this.updateAfterDrag();
        this.clearDrag();
      }
    }
    /**
     * click event handler
     */

  }, {
    key: "clickHandler",
    value: function clickHandler(e) {
      // if the dragged element is a link
      // prevent browsers from folowing the link
      if (this.drag.preventClick) {
        e.preventDefault();
      }

      this.drag.preventClick = false;
    }
    /**
     * Remove item from carousel.
     * @param {number} index - Item index to remove.
     * @param {function} callback - Optional callback to call after remove.
     */

  }, {
    key: "remove",
    value: function remove(index, callback) {
      if (index < 0 || index >= this.innerElements.length) {
        throw new Error('Item to remove doesn\'t exist 😭');
      } // Shift sliderFrame back by one item when:
      // 1. Item with lower index than currenSlide is removed.
      // 2. Last item is removed.


      var lowerIndex = index < this.currentSlide;
      var lastItem = this.currentSlide + this.perPage - 1 === index;

      if (lowerIndex || lastItem) {
        this.currentSlide--;
      }

      this.innerElements.splice(index, 1); // build a frame and slide to a currentSlide

      this.buildSliderFrame();

      if (callback) {
        callback.call(this);
      }
    }
    /**
     * Insert item to carousel at particular index.
     * @param {HTMLElement} item - Item to insert.
     * @param {number} index - Index of new new item insertion.
     * @param {function} callback - Optional callback to call after insert.
     */

  }, {
    key: "insert",
    value: function insert(item, index, callback) {
      if (index < 0 || index > this.innerElements.length + 1) {
        throw new Error('Unable to inset it at this index 😭');
      }

      if (this.innerElements.indexOf(item) !== -1) {
        throw new Error('The same item in a carousel? Really? Nope 😭');
      } // Avoid shifting content


      var shouldItShift = index <= this.currentSlide > 0 && this.innerElements.length;
      this.currentSlide = shouldItShift ? this.currentSlide + 1 : this.currentSlide;
      this.innerElements.splice(index, 0, item); // build a frame and slide to a currentSlide

      this.buildSliderFrame();

      if (callback) {
        callback.call(this);
      }
    }
    /**
     * Prepernd item to carousel.
     * @param {HTMLElement} item - Item to prepend.
     * @param {function} callback - Optional callback to call after prepend.
     */

  }, {
    key: "prepend",
    value: function prepend(item, callback) {
      this.insert(item, 0);

      if (callback) {
        callback.call(this);
      }
    }
    /**
     * Append item to carousel.
     * @param {HTMLElement} item - Item to append.
     * @param {function} callback - Optional callback to call after append.
     */

  }, {
    key: "append",
    value: function append(item, callback) {
      this.insert(item, this.innerElements.length + 1);

      if (callback) {
        callback.call(this);
      }
    }
    /**
     * Removes listeners and optionally restores to initial markup
     * @param {boolean} restoreMarkup - Determinants about restoring an initial markup.
     * @param {function} callback - Optional callback function.
     */

  }, {
    key: "destroy",
    value: function destroy() {
      var restoreMarkup = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var callback = arguments.length > 1 ? arguments[1] : undefined;
      this.detachEvents();
      this.selector.style.cursor = 'auto';

      if (restoreMarkup) {
        var slides = document.createDocumentFragment();

        for (var i = 0; i < this.innerElements.length; i++) {
          slides.appendChild(this.innerElements[i]);
        }

        this.selector.innerHTML = '';
        this.selector.appendChild(slides);
        this.selector.removeAttribute('style');
      }

      if (callback) {
        callback.call(this);
      }
    }
  }], [{
    key: "mergeSettings",
    value: function mergeSettings(options) {
      var settings = {
        selector: '.siema',
        duration: 200,
        easing: 'ease-out',
        perPage: 1,
        startIndex: 0,
        draggable: true,
        multipleDrag: true,
        threshold: 20,
        loop: false,
        rtl: false,
        onInit: function onInit() {},
        onChange: function onChange() {}
      };
      var userSttings = options;

      for (var attrname in userSttings) {
        settings[attrname] = userSttings[attrname];
      }

      return settings;
    }
    /**
     * Determine if browser supports unprefixed transform property.
     * Google Chrome since version 26 supports prefix-less transform
     * @returns {string} - Transform property supported by client.
     */

  }, {
    key: "webkitOrNot",
    value: function webkitOrNot() {
      var style = document.documentElement.style;

      if (typeof style.transform === 'string') {
        return 'transform';
      }

      return 'WebkitTransform';
    }
  }]);

  return Siema;
}();

var _default = Siema;
exports["default"] = _default;

},{}],3:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var Tabs = /*#__PURE__*/function () {
  function Tabs(selector) {
    var activeClass = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'active';

    _classCallCheck(this, Tabs);

    this.$tabs = document.querySelectorAll(selector);

    if (this.$tabs.length <= 0) {
      return;
    }

    this.$activeClass = activeClass;
    var curTab = false;
    this.$tabs.forEach(function (tab) {
      if (!curTab) {
        curTab = tab.classList.contains(activeClass) ? tab : false;
      }
    });
    this.$curTab = curTab ? curTab : this.$tabs[0];
    this.setActive(this.$curTab);
    this.updateTabs();
    this.bindEvents();
  }

  _createClass(Tabs, [{
    key: "bindEvents",
    value: function bindEvents() {
      var _this = this;

      this.$tabs.forEach(function (tab) {
        tab.addEventListener('click', function (e) {
          e.preventDefault();

          _this.setActive(this);

          _this.updateTabs();
        });
      });
    }
  }, {
    key: "setActive",
    value: function setActive(newTab) {
      var activeClass = this.$activeClass;
      this.$tabs.forEach(function (tab) {
        tab.classList.remove(activeClass);
      });
      newTab.classList.add(activeClass);
      this.$curTab = newTab;
    }
  }, {
    key: "updateTabs",
    value: function updateTabs() {
      var tabContainer = false,
          activeClass = this.$activeClass;
      this.$tabs.forEach(function (tab) {
        var tabContainerId = tab.getAttribute('href');
        tabContainer = document.querySelector(tabContainerId);

        if (!tabContainer) {
          tabContainer = false;
          return;
        }

        tabContainer.style.display = 'none';

        if (tab.classList.contains(activeClass)) {
          tabContainer.style.display = 'block';
        }
      });
    }
  }]);

  return Tabs;
}();

var _default = Tabs;
exports["default"] = _default;

},{}],4:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var burgerMenu = /*#__PURE__*/function () {
  function burgerMenu(selector) {
    var _this = this;

    _classCallCheck(this, burgerMenu);

    this.$element = document.querySelector(selector); // get the class name without the dot for later use

    this.baseClass = selector.split('.')[1];
    this.menuIsVisible = false; // cache selectors for better performance

    this.$body = document.querySelector('body');
    this.$button = document.querySelector(selector + '__button');
    this.$content = document.querySelector(selector + '__content'); // setup event listeners

    this.toggleMenu = this.toggleMenu.bind(this);
    this.$button.addEventListener('click', this.toggleMenu);
    this.updateTransitionClass = this.updateTransitionClass.bind(this);
    this.$content.addEventListener('transitionend', this.updateTransitionClass);
    this.hideSubmenu = this.hideSubmenu.bind(this);
    this.$content.addEventListener('click', this.hideSubmenu);
    this.showSubmenu = this.showSubmenu.bind(this);
    document.querySelectorAll(selector + '__submenuTrigger').forEach(function (el) {
      el.addEventListener('click', _this.showSubmenu);
    });
    this.toggleDropdown = this.toggleDropdown.bind(this);
    document.querySelectorAll(selector + '__dropdownTrigger').forEach(function (el) {
      el.addEventListener('click', _this.toggleDropdown);
    });
  }

  _createClass(burgerMenu, [{
    key: "toggleMenu",
    value: function toggleMenu() {
      this.menuIsVisible = !this.menuIsVisible;

      if (this.menuIsVisible) {
        this.$content.classList.add(this.baseClass + '__content--transitioning');
      }

      this.$body.classList.toggle('prevent-scroll');
      this.$element.classList.toggle(this.baseClass + '--visible');
    }
  }, {
    key: "updateTransitionClass",
    value: function updateTransitionClass() {
      if (!this.menuIsVisible) {
        this.$content.classList.remove(this.baseClass + '__content--transitioning');
      }
    }
  }, {
    key: "showSubmenu",
    value: function showSubmenu(e) {
      e.target.parentNode.classList.add(this.baseClass + '__listItem--active');
      this.$currentSubmenu = e.target.parentNode;
    }
  }, {
    key: "hideSubmenu",
    value: function hideSubmenu(e) {
      // Close on clicks outside of the submenu or in case the close button was clicked
      if (!this.$currentSubmenu.contains(e.target) || e.target.classList.contains(this.baseClass + '__submenuClose')) {
        e.preventDefault();
        this.$currentSubmenu.classList.remove(this.baseClass + '__listItem--active');
        this.$currentSubmenu = '';
      }
    }
  }, {
    key: "toggleDropdown",
    value: function toggleDropdown(e) {
      e.target.parentNode.classList.toggle(this.baseClass + '__listItem--dropdown-visible');

      if (!e.target.nextElementSibling.style.height || e.target.nextElementSibling.style.height === '0px') {
        // Show dropdown
        // Get the height of the first child element and use it for calculating the target dropdown height
        var elementHeight = e.target.nextElementSibling.children[0].clientHeight;
        e.target.nextElementSibling.style.height = elementHeight * e.target.nextElementSibling.children.length + 'px';
      } else {
        // Hide dropdown
        e.target.nextElementSibling.style.height = '0px';
      }
    }
  }]);

  return burgerMenu;
}();

var _default = burgerMenu;
exports["default"] = _default;

},{}],5:[function(require,module,exports){
"use strict";

var _burgerMenu = _interopRequireDefault(require("./burgerMenu"));

var _Likes = _interopRequireDefault(require("./Likes"));

var _Siema = _interopRequireDefault(require("./Siema"));

var _Tabs = _interopRequireDefault(require("./Tabs"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

if (window.NodeList && !NodeList.prototype.forEach) {
  NodeList.prototype.forEach = Array.prototype.forEach;
}

if (!String.prototype.startsWith) {
  String.prototype.startsWith = function (searchString, position) {
    position = position || 0;
    return this.substr(position, searchString.length) === searchString;
  };
}
/*import 'babel-polyfill';*/
// собираем меню (все страницы)


new _burgerMenu["default"]('.burger-menu'); //////////////////////////////////////////////////////////////////////////////
// некоторые функции анимации (возможно все страницы, но пока instruction_nmfo_v2.html)

function fadeOut(el) {
  el.style.opacity = 1;

  (function fade() {
    if ((el.style.opacity -= .1) < 0) {
      el.style.display = "none";
    } else {
      requestAnimationFrame(fade);
    }
  })();
}

function fadeIn(el, display) {
  el.style.opacity = 0;
  el.style.display = display || "block";

  (function fade() {
    var val = parseFloat(el.style.opacity);

    if (!((val += .1) > 1)) {
      el.style.opacity = val;
      requestAnimationFrame(fade);
    }
  })();
} // подключаем лайки (instruction_nmfo_v2.html - страница инструкции НМФО v2)


if (document.querySelector(".likes") !== undefined && document.querySelector(".likes") !== null) new _Likes["default"]('.likes'); //////////////////////////////////////////////////////////////////////////////
// слайдер (instruction_nmfo_v2.html - страница инструкции НМФО v2)

var instructionBodies = document.querySelectorAll(".instructions_v2-body__body"),
    timerId;
instructionBodies.forEach(function (instructionBody) {
  if (instructionBody.querySelector(".siema") !== undefined && instructionBody.querySelector(".siema") !== null) {
    // определяем мобильник или нет (скроллим или по клику запускаем переход на новый слайд)
    var draggable = true;
    var selector = '#' + instructionBody.id + ' .siema';
    var mySiema = new _Siema["default"]({
      draggable: draggable,
      selector: selector,
      onChange: function onChange() {
        var elements = instructionBody.querySelectorAll(".slider__button");

        var _iterator = _createForOfIteratorHelper(elements),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var _elem = _step.value;

            _elem.classList.remove("slider__button--active");
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }

        instructionBody.querySelector(".slider__button--" + mySiema.currentSlide).classList.add("slider__button--active");
        instructionBody.querySelector(".instructions_v2-body__slider__title__step-number").innerHTML = mySiema.currentSlide + 1;
        var elem = instructionBody.querySelector(".instructions_v2-body__slider__title__text__itm--active");

        if (elem) {
          fadeOut(elem);
          elem.classList.remove("instructions_v2-body__slider__title__text__itm--active");
        }

        if (timerId) {
          clearTimeout(timerId);
        }

        timerId = setTimeout(function () {
          instructionBody.querySelectorAll('.instructions_v2-body__slider__title__text__itm').forEach(function (el) {
            el.style.display = "none";
          });
          fadeIn(instructionBody.querySelector(".instructions_v2-body__slider__title__text__itm--" + mySiema.currentSlide));
          instructionBody.querySelector(".instructions_v2-body__slider__title__text__itm--" + mySiema.currentSlide).classList.add("instructions_v2-body__slider__title__text__itm--active");
          timerId = null;
        }, 300);
      }
    }); // добавляем пагинацию внизу слайдера

    _Siema["default"].prototype.addPagination = function () {
      var _this = this;

      var _loop = function _loop(i) {
        var btn = document.createElement('a');
        btn.classList.add("slider__button");
        btn.classList.add("slider__button--" + i);
        if (i == 0) btn.classList.add("slider__button--active");
        btn.textContent = i + 1;
        btn.addEventListener('click', function () {
          return _this.goTo(i);
        });
        instructionBody.querySelector(".siema__navigation__counter").appendChild(btn); // selector
      };

      for (var i = 0; i < this.innerElements.length; i++) {
        _loop(i);
      }
    };

    mySiema.addPagination(); // биндим клики по кнопкам вперед - назад.

    var prev = instructionBody.querySelector('.prev');
    var next = instructionBody.querySelector('.next');
    prev.addEventListener('click', function (e) {
      e.preventDefault();
      var slidesCount = instructionBody.querySelectorAll('.instructions_v2-body__slider__title__text__itm').length;

      if (instructionBody.querySelector(".instructions_v2-body__slider__title__step-number").innerHTML == 1) {
        mySiema.goTo(slidesCount - 1);
      } else {
        mySiema.prev();
      }
    });
    next.addEventListener('click', function (e) {
      e.preventDefault();
      var slidesCount = instructionBody.querySelectorAll('.instructions_v2-body__slider__title__text__itm').length;

      if (instructionBody.querySelector(".instructions_v2-body__slider__title__step-number").innerHTML == slidesCount) {
        mySiema.goTo(0);
      } else {
        mySiema.next();
      }
    });
    document.querySelectorAll('.img-next').forEach(function (item) {
      item.addEventListener('click', function () {
        if (!draggable) mySiema.next();
      });
    });
    var prevmobile = document.querySelector('.prev--mobile');
    var nextmobile = document.querySelector('.next--mobile');
    prevmobile.addEventListener('click', //() => mySiema.prev()
    function (e) {
      e.preventDefault();
      mySiema.prev();
    });
    nextmobile.addEventListener('click', //() => mySiema.next()
    function (e) {
      e.preventDefault();
      mySiema.next();
    });
  }
}); //import ValidateForm from './ValidateForm';
// добавляем валидацию на форму авторизации (auth.html - авторизация)
//let auth_selector = ".auth-body__form";
//if (document.querySelector(auth_selector) !== undefined && document.querySelector(auth_selector) !== null)
//    new ValidateForm(auth_selector);
//////////////////////////////////////////////////////////////////////////////
// Табы переключения  (registration.html регистрация)

if (document.querySelector(".registration-body__tabs-container") !== undefined && document.querySelector(".registration-body__tabs-container") !== null) {
  var tabs = document.querySelector(".registration-body__tabs-container");
  var tabsBtns = tabs.querySelectorAll(".registration-body__tabs-container__btns__itm");
  var tabsContents = tabs.querySelectorAll(".registration-body__tabs-container__content");

  for (var i = 0; i < tabsContents.length; i++) {
    tabsContents[i].style.display = i === 0 ? "block" : "none";
  }

  tabs.addEventListener("click", function (event) {
    if (event.target.className === "registration-body__tabs-container__btns__itm") {
      for (var _i = 0; _i < tabsBtns.length; _i++) {
        if (event.target === tabsBtns[_i]) {
          for (var j = 0; j < tabsContents.length; j++) {
            tabsContents[j].style.display = _i === j ? "block" : "none";
          }

          tabsBtns[_i].classList.add("registration-body__tabs-container__btns__itm--active");
        } else {
          tabsBtns[_i].classList.remove("registration-body__tabs-container__btns__itm--active");
        }
      }
    }
  });
} // добавляем валидацию на форму регистрации (registration.html регистрация)

/*let reg_selector = ".registration__form";
if (document.querySelector(reg_selector) !== undefined && document.querySelector(reg_selector) !== null) {
    new ValidateForm(reg_selector);
}
*/
//////////////////////////////////////////////////////////////////////////////
// Выпадающая подсказка для жителей Крыма. (auth.html - авторизация)


var krimTimerId = null;
document.getElementById('auth-info-btn') !== undefined && document.getElementById('auth-info-btn') !== null && document.getElementById('auth-info-btn').addEventListener("click", function () {
  var infoCont = document.getElementById("auth-info-container"),
      classList = infoCont.classList,
      interval = 10,
      stepVal = 5;

  var classIndex = _toConsumableArray(classList).indexOf("active");

  if (krimTimerId !== null) clearInterval(krimTimerId);

  if (classIndex == -1) {
    infoCont.classList.add("active");
    var infoDesc = document.querySelector(".auth-info__desc"),
        infoDescСhild = document.querySelectorAll(".auth-info__desc>*"),
        infoDescH = 0,
        infoDescNewH = 0;
    infoDesc.style.height = "0px";
    infoDescСhild.forEach(function (el) {
      infoDescH += el.offsetHeight;
    });
    krimTimerId = setInterval(function () {
      infoDescNewH += stepVal;
      infoDesc.style.height = infoDescNewH + "px";
      if (infoDescNewH >= infoDescH) clearInterval(krimTimerId);
    }, interval);
  } else {
    var _infoDesc = document.querySelector(".auth-info__desc"),
        _infoDescH = _infoDesc.offsetHeight,
        _infoDescNewH = _infoDescH;

    krimTimerId = setInterval(function () {
      _infoDescNewH -= stepVal;
      _infoDesc.style.height = _infoDescNewH + "px";

      if (_infoDescNewH <= 0) {
        clearInterval(krimTimerId);
        infoCont.classList.remove("active");
      }
    }, interval);
  }
}); //////////////////////////////////////////////////////////////////////////////
// страница, где есть небольшая форма в футере (index.html, module.html)

/*
const validate = (email) => {
    const expression = /(?!.*\.{2})^([a-z\d!#$%&'*+\-\/=?^_`{|}~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+(\.[a-z\d!#$%&'*+\-\/=?^_`{|}~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+)*|"((([ \t]*\r\n)?[ \t]+)?([\x01-\x08\x0b\x0c\x0e-\x1f\x7f\x21\x23-\x5b\x5d-\x7e\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|\\[\x01-\x09\x0b\x0c\x0d-\x7f\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))*(([ \t]*\r\n)?[ \t]+)?")@(([a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|[a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF][a-z\d\-._~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]*[a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])\.)+([a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|[a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF][a-z\d\-._~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]*[a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])\.?$/i;
    return expression.test(String(email).toLowerCase())
}
document.getElementById("content-footer__form__button__action") !== undefined &&
document.getElementById("content-footer__form__button__action") !== null &&
document.getElementById("content-footer__form__button__action").addEventListener("click", () => {
    let text_wrapper = document.getElementById('content-footer__form__answer');
    text_wrapper.remove('content-footer__form__answer--error');
    text_wrapper.remove('content-footer__form__answer--ok');
    text_wrapper.innerHTML = "";

    if (validate(document.getElementById('content-footer__form__input__value').value)) {
        text_wrapper.add('content-footer__form__answer--ok');
        text_wrapper.innerHTML = "Заявка отправлена";
    } else {
        text_wrapper.add('content-footer__form__answer--error');
        text_wrapper.innerHTML = "Ошибка в e-mail адресе";
    }
    ;
});*/

new _Tabs["default"]('.instructions_v2__tabs-selector__itm');

},{"./Likes":1,"./Siema":2,"./Tabs":3,"./burgerMenu":4}]},{},[5]);